module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/039-monaco-40f1ded9de281189d90f59b5e81cdebd.svg";